import React from 'react';
import { Row, Col } from 'react-bootstrap';

const AppTitle = () => {
  return (
      <Row>
        <Col className="app-title">
          <h2>Airport Pickup And Temporary Housing(APATH) - International</h2>
        </Col>
      </Row>
  );
};

export default AppTitle;